import base_ds from "@/services/base_datasource_service";
import request from "@/utils/request";
import { AxiosResponse } from "axios";
import { Purchase, PurchaseTotal } from "./models-service";
import { exportToExcelFile } from "@/utils/excel";

export const route_ns = `purchases`;
export const route_ns_total = `total_purchases`;

class PurchasesInputService {
  public crud = base_ds.getBaseCrud(route_ns);

  public async getWithFilter(ids: String[], id_facility: number, periods: String[]): Promise<Purchase[]> {
    const url = `${route_ns}?filter=[["id_cut","in",${JSON.stringify(ids)}],"and",["id_eco_facility","=","${id_facility}"],"and",["month","in",${JSON.stringify(periods)}]]`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }

  public async save(pack: Purchase[]) {
    return await request({
      url: route_ns,
      method: "post",
      data: {data: pack},
    });
  }

  public async delete(list: Purchase[]) {
    return await request({
      url: route_ns,
      method: "delete",
      data: {data: list},
    });
  }

  public async getTotalWithFilter(ids: String[], id_facility: number, periods: String[]): Promise<PurchaseTotal[]> {
    const url = `${route_ns_total}?filter=[["id_cut","in",${JSON.stringify(ids)}],"and",["id_eco_facility","=","${id_facility}"],"and",["month","in",${JSON.stringify(periods)}]]`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }

  public async getChangedTotal(id_cut: string, id_facility: number, blocks: string[], periods: String[]): Promise<PurchaseTotal[]> {
    let is_total = `["block","in",${JSON.stringify(blocks)}]`;
    if (blocks.includes('total')) {
      is_total = `[["block","in",${JSON.stringify(blocks)}],"or",["is_total","=","true"]]`;
    }
    const url = `${route_ns_total}?filter=[["id_cut","=","${id_cut}"],"and",["id_eco_facility","=","${id_facility}"],"and",${is_total},"and",["month","in",${JSON.stringify(periods)}]]`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }

  public async saveTotal(pack: PurchaseTotal[]) {
    return await request({
      url: route_ns_total,
      method: "post",
      data: {data: pack},
    });
  }

  public async exportToExcel(data: any, filename: string | null = null) {
    await exportToExcelFile(data, route_ns_total, filename);
  }
}

export default new PurchasesInputService();
